<div>
    <h1 class="text-center">Session timed out</h1>

    <p class="lead" style="text-align: center;">Due to inactivity your session has been timed out.</p>

    <p class="lead" style="text-align: center;"> In order to proceed, please log in. Continue as: </p>

    <p class="text-center">


          <button class="btn btn-primary" (click)="goToProducerAuthPage()"> Producer </button>&nbsp;
        <button class="btn btn-primary" (click)="goToProposedInsuredAuthPage()"> Proposed Insured </button>


    </p>
</div>
